var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 56,
    viewBox: "0 0 40 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 56,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0901 9.30005H17.9041L14.9921 27.5H17.6181L18.1121 24.198H21.6221L22.1161 27.5H25.0021L22.0901 9.30005ZM19.8281 12.524H19.8801L21.2321 21.728H18.4761L19.8281 12.524Z",
    fill: "#2C2833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8627 36.3039C16.8627 34.5712 18.2673 33.1666 20 33.1666C21.7326 33.1666 23.1372 34.5712 23.1372 36.3039C23.1372 36.7544 23.0423 37.1827 22.8713 37.5699C22.959 37.5625 23.0477 37.5588 23.1372 37.5588C24.8699 37.5588 26.2745 38.9634 26.2745 40.696C26.2745 42.4287 24.8699 43.8333 23.1372 43.8333C22.4658 43.8333 21.8436 43.6223 21.3333 43.2631V47.1666H18.6666V43.2631C18.1564 43.6224 17.5342 43.8333 16.8627 43.8333C15.1301 43.8333 13.7255 42.4287 13.7255 40.696C13.7255 38.9634 15.1301 37.5588 16.8627 37.5588C16.9523 37.5588 17.041 37.5625 17.1286 37.5699C16.9577 37.1827 16.8627 36.7544 16.8627 36.3039Z",
    fill: "#2C2833"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCa);
export default __webpack_public_path__ + "static/media/CA.1ed293c4a35b9c9510767048c8dea422.svg";
export { ForwardRef as ReactComponent };